import { dryrun } from "../api/ao-connection"

import { QueryObserverResult, useQuery } from "@tanstack/react-query"

import { Message, Tag } from "@/api/ao"
import { getTagValue } from "@/utils/arweave"
import { getHBBaseUrl } from "@/utils/hb-router"

/**
 * Get token total supply
 */
export async function getTotalSupplyHB(tokenId: string): Promise<bigint> {
  console.log("GET TOTAL SUPPLY HB", tokenId)
  const HB_API = getHBBaseUrl(tokenId)

  const response = await fetch(`${HB_API}/${tokenId}~process@1.0/compute/token-info/supply`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })

  if (!response.ok) {
    throw new Error("Failed to fetch total supply")
  }

  const data = await response.text()

  return BigInt(data)
}

export async function getTotalSupplyDryRun(tokenId: string): Promise<bigint> {
  console.log("GET TOTAL SUPPLY", tokenId)
  const result = await dryrun({
    process: tokenId,
    tags: [{ name: "Action", value: "Total-Supply" }],
  })

  if (result.Messages.length === 0)
    throw new Error(`No response from (get) Total-Supply (${tokenId})`)
  const message = result.Messages[0]

  const tags = message.Tags as Tag[]
  const tag = tags.find((x) => x.name === "Total-Supply")
  const valueAsString = tag?.value || message.Data

  /*   let value = parseFloat(valueAsString ? valueAsString : "")

  if (isNaN(value)) throw new Error("Response malformed")
 */

  return BigInt(valueAsString)
}

export async function getTotalSupply(tokenId: string): Promise<bigint> {
  try {
    const response = await getTotalSupplyHB(tokenId)

    return response
  } catch (error) {
    console.error("Error fetching total supply from HB:", error)

    // Fallback to dryrun if HB fails
    try {
      const response = await getTotalSupplyDryRun(tokenId)
      return response
    } catch (dryRunError) {
      console.error("Error fetching total supply from dryrun:", dryRunError)
      throw dryRunError
    }
  }
}

/**
 * Total supply hook
 */
export function useTotalSupply(
  tokenId: string,
): [bigint, boolean, () => Promise<QueryObserverResult<bigint, Error>>] {
  const {
    data = 0n,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["total-supply", tokenId],
    queryFn: async () => {
      return await getTotalSupply(tokenId)
    },
    enabled: !!tokenId,
  })

  return [data, isLoading, refetch]
}
